import { AuditProgramDepartmentSectionBean } from '../model/audit-program-department-section';
import { AuditorBenchAuditDetailScopeDTO } from '../model/auditor-bench-audit-detail-scope-dto';
export class AuditorBenchAuditDetailResponseDTO{
    auditDetailCheckboxCount: AuditDetailCheckboxCount = new AuditDetailCheckboxCount();
    departmentSectionList: AuditProgramDepartmentSectionBean[];
    auditorBenchAuditDetailScopeList: AuditorBenchAuditDetailScopeDTO[];
    totalScopeCount : string =  '0';
}

export class AuditDetailCheckboxCount {
    pendingCount: number = 0;
    inWfCount: number = 0;
    ncCount: number = 0;
    pncCount: number = 0;
    closedCount: number = 0;
    naCount: number = 0;
    allCount: number = 0;
    returnCount: number = 0;
    notStartedCount: number = 0;
    planCount: number = 0;
    doCount: number = 0;
    checkCount: number = 0;
    actCount: number = 0;
}